import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { InformationSharedPopupComponent } from '../information-shared-popup/information-shared-popup.component';
import { Easy2Service } from '../../../service/easy2.service';
import { UserdataService } from '../../../service/userdata.service';

@Component({
  selector: 'app-easy-two-popup',
  standalone: false,
  templateUrl: './easy-two-popup.component.html',
  styleUrl: './easy-two-popup.component.scss'
})
export class EasyTwoPopupComponent {
  checked: boolean = false;
  userdata: any;

  constructor(
    private dialogRef: MatDialogRef<EasyTwoPopupComponent>,
    private dialog: MatDialog,
    private easy2Service: Easy2Service,
    userdataService: UserdataService
  ) {
    userdataService.data.subscribe(data => {
      this.userdata = data;
    })
  }

  closeDialog() {
    this.dialogRef.close()
  }

  openInfoSharedPopup() {
    this.easy2Service.checkAndCreateAccount(this.userdata.email, this.userdata.projectData.own[0].projectId)
    this.dialog.open(InformationSharedPopupComponent, {
      width: '500px',
      height: '480px'
    });
  }

  createEasy2() {
    this.dialogRef.close({ data: true })
  }
}
